/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const scheduleArchivePreviewResponseOutputScheduleIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const scheduleArchivePreviewResponseOutputExpectedVersionExclusiveMin = 0;
export const scheduleArchivePreviewResponseOutputExpectedVersionMax = 9007199254740991;

export const scheduleArchivePreviewResponseOutputPreviewFingerprintMax = 256;

export const scheduleArchivePreviewResponseOutputObservedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const scheduleArchivePreviewResponseOutputSearchedUntilRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const scheduleArchivePreviewResponseOutputRoutinesItemRoutineIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const scheduleArchivePreviewResponseOutputRoutinesItemCurrentCoverageItemUserIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const scheduleArchivePreviewResponseOutputRoutinesItemCurrentCoverageItemDisplayNameMax = 500;

export const scheduleArchivePreviewResponseOutputRoutinesItemCurrentCoverageItemOriginalUserIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const scheduleArchivePreviewResponseOutputRoutinesItemCurrentCoverageItemOverrideIdOneRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const scheduleArchivePreviewResponseOutputRoutinesItemCurrentCoverageItemEndRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const scheduleArchivePreviewResponseOutputRoutinesItemCurrentCoverageMax = 20;

export const scheduleArchivePreviewResponseOutputRoutinesItemPendingVersionsItemIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const scheduleArchivePreviewResponseOutputRoutinesItemPendingVersionsItemEffectiveAtRegExp =
  new RegExp(
    '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
  );
export const scheduleArchivePreviewResponseOutputRoutinesItemPendingVersionsMax = 2;

export const scheduleArchivePreviewResponseOutputRoutinesItemOverridesItemOverrideIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const scheduleArchivePreviewResponseOutputRoutinesItemOverridesItemSubstituteUserIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );
export const scheduleArchivePreviewResponseOutputRoutinesItemOverridesItemDisplayNameMax = 500;

export const scheduleArchivePreviewResponseOutputRoutinesItemOverridesItemStartRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const scheduleArchivePreviewResponseOutputRoutinesItemOverridesItemEndRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const scheduleArchivePreviewResponseOutputRoutinesItemOverridesMax = 1000;

export const scheduleArchivePreviewResponseOutputRoutinesItemNewGapsItemStartRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const scheduleArchivePreviewResponseOutputRoutinesItemNewGapsItemEndRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const scheduleArchivePreviewResponseOutputRoutinesItemNewGapsMax = 10000;

export const scheduleArchivePreviewResponseOutputRoutinesMax = 10;

export const ScheduleArchivePreviewResponseOutput = zod.object({
  scheduleId: zod.uuid().regex(scheduleArchivePreviewResponseOutputScheduleIdRegExp),
  expectedVersion: zod
    .int()
    .gt(scheduleArchivePreviewResponseOutputExpectedVersionExclusiveMin)
    .max(scheduleArchivePreviewResponseOutputExpectedVersionMax),
  previewFingerprint: zod
    .string()
    .min(1)
    .max(scheduleArchivePreviewResponseOutputPreviewFingerprintMax),
  observedAt: zod.iso
    .datetime({ offset: true })
    .regex(scheduleArchivePreviewResponseOutputObservedAtRegExp),
  searchedUntil: zod.iso
    .datetime({ offset: true })
    .regex(scheduleArchivePreviewResponseOutputSearchedUntilRegExp),
  routines: zod
    .array(
      zod.object({
        routineId: zod
          .uuid()
          .regex(scheduleArchivePreviewResponseOutputRoutinesItemRoutineIdRegExp),
        name: zod.unknown().and(zod.unknown()),
        currentCoverage: zod
          .array(
            zod.object({
              userId: zod
                .uuid()
                .regex(
                  scheduleArchivePreviewResponseOutputRoutinesItemCurrentCoverageItemUserIdRegExp,
                ),
              displayName: zod
                .string()
                .min(1)
                .max(
                  scheduleArchivePreviewResponseOutputRoutinesItemCurrentCoverageItemDisplayNameMax,
                ),
              originalUserId: zod
                .uuid()
                .regex(
                  scheduleArchivePreviewResponseOutputRoutinesItemCurrentCoverageItemOriginalUserIdRegExp,
                ),
              overrideId: zod.union([
                zod
                  .uuid()
                  .regex(
                    scheduleArchivePreviewResponseOutputRoutinesItemCurrentCoverageItemOverrideIdOneRegExp,
                  ),
                zod.null(),
              ]),
              end: zod.iso
                .datetime({ offset: true })
                .regex(
                  scheduleArchivePreviewResponseOutputRoutinesItemCurrentCoverageItemEndRegExp,
                ),
            }),
          )
          .max(scheduleArchivePreviewResponseOutputRoutinesItemCurrentCoverageMax),
        pendingVersions: zod
          .array(
            zod.object({
              id: zod
                .uuid()
                .regex(scheduleArchivePreviewResponseOutputRoutinesItemPendingVersionsItemIdRegExp),
              effectiveAt: zod.iso
                .datetime({ offset: true })
                .regex(
                  scheduleArchivePreviewResponseOutputRoutinesItemPendingVersionsItemEffectiveAtRegExp,
                ),
              sectionChange: zod.boolean(),
              rotationChange: zod.boolean(),
            }),
          )
          .max(scheduleArchivePreviewResponseOutputRoutinesItemPendingVersionsMax),
        overrides: zod
          .array(
            zod.object({
              overrideId: zod
                .uuid()
                .regex(
                  scheduleArchivePreviewResponseOutputRoutinesItemOverridesItemOverrideIdRegExp,
                ),
              substituteUserId: zod
                .uuid()
                .regex(
                  scheduleArchivePreviewResponseOutputRoutinesItemOverridesItemSubstituteUserIdRegExp,
                ),
              displayName: zod
                .string()
                .min(1)
                .max(scheduleArchivePreviewResponseOutputRoutinesItemOverridesItemDisplayNameMax),
              start: zod.iso
                .datetime({ offset: true })
                .regex(scheduleArchivePreviewResponseOutputRoutinesItemOverridesItemStartRegExp),
              end: zod.iso
                .datetime({ offset: true })
                .regex(scheduleArchivePreviewResponseOutputRoutinesItemOverridesItemEndRegExp),
            }),
          )
          .max(scheduleArchivePreviewResponseOutputRoutinesItemOverridesMax),
        newGaps: zod
          .array(
            zod.object({
              start: zod.iso
                .datetime({ offset: true })
                .regex(scheduleArchivePreviewResponseOutputRoutinesItemNewGapsItemStartRegExp),
              end: zod.iso
                .datetime({ offset: true })
                .regex(scheduleArchivePreviewResponseOutputRoutinesItemNewGapsItemEndRegExp),
            }),
          )
          .max(scheduleArchivePreviewResponseOutputRoutinesItemNewGapsMax),
      }),
    )
    .max(scheduleArchivePreviewResponseOutputRoutinesMax),
});

export type ScheduleArchivePreviewResponseOutput = zod.input<
  typeof ScheduleArchivePreviewResponseOutput
>;
export type ScheduleArchivePreviewResponseOutputOutput = zod.output<
  typeof ScheduleArchivePreviewResponseOutput
>;
